import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityItem } from "../../entity/EntityItem";

export class DtoItemsGetRes extends EntityItem {
  public items: EntityItem[]  = [];
}
